import script from "./BeachGuide.vue?vue&type=script&lang=ts&setup=true"
export * from "./BeachGuide.vue?vue&type=script&lang=ts&setup=true"

import "./BeachGuide.vue?vue&type=style&index=0&id=540e7e69&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-540e7e69"]])

export default __exports__